import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import 'trix';
import 'trix/dist/trix.css';
import AmsAlert from '../../../utils/AmsAlert';
import { fetchAmsLookup } from '../../../actions/lookupActions';

const Editor = ({
  value,
  onChange,
  onFileUpload,
  onFileDelete,
  focusOnInit = false,
  id = 'trix-editor-instance',
  disabled = false,
}) => {
  const trixEditor = useRef(null);

  const [showFileTypeDialog, setShowFileTypeDialog] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let toolbar = null;
    var editor = document.getElementById(id);
    if (editor) {
      var dis = disabled === 'disabled' || disabled === true;

      editor.setAttribute('contentEditable', !dis);

      if (dis) editor.parentElement.classList.add('trix-editor-disabled');
      else editor.parentElement.classList.remove('trix-editor-disabled');

      let sibling = editor.parentElement.firstElementChild;
      while (sibling) {
        if (
          sibling !== editor &&
          sibling.tagName.toLowerCase() === 'trix-toolbar'
        ) {
          toolbar = sibling;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
    }
    // disable/enable buttons in the toolbar
    if (toolbar) {
      const buttons = toolbar.querySelectorAll('button');
      if (dis) {
        buttons.forEach(button => button.setAttribute('disabled', true));
      } else {
        buttons.forEach(button => button.removeAttribute('disabled'));
      }
    }
  }, [disabled]);

  useEffect(() => {
    let toolbar = null;
    var editor = document.getElementById(id);
    if (editor) {
      var dis = disabled === 'disabled' || disabled === true;

      editor.setAttribute('contentEditable', !dis);

      if (dis) editor.parentElement.classList.add('trix-editor-disabled');
      else editor.parentElement.classList.remove('trix-editor-disabled');

      let sibling = editor.parentElement.firstElementChild;
      while (sibling) {
        if (
          sibling !== editor &&
          sibling.tagName.toLowerCase() === 'trix-toolbar'
        ) {
          toolbar = sibling;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
    }
    // disable/enable buttons in the toolbar
    if (toolbar) {
      const buttons = toolbar.querySelectorAll('button');
      if (dis) {
        buttons.forEach(button => button.setAttribute('disabled', true));
      } else {
        buttons.forEach(button => button.removeAttribute('disabled'));
      }
    }
  }, [disabled]);

  useEffect(() => {
    trixEditor.current.addEventListener('trix-change', e => {
      onChange(trixEditor.current.inputElement.value);
    });
    trixEditor.current.addEventListener('trix-attachment-add', e => {
      const fileType = e.attachment.file && e.attachment.file.type;
      dispatch(fetchAmsLookup('fileTypes')).then(response => {
        if (response.lookups && response.lookups.length) {
          const lookupFileTypes = response.lookups;
          const parent = _.find(lookupFileTypes, { parent: true }); // Find lookup category parent.
          const activeFileTypes = _.filter(lookupFileTypes, {
            parent: false,
            active: true,
          });
          if (parent && parent.active) {
            if (activeFileTypes.length) {
              let allowFileTypes = activeFileTypes.map(fileType => {
                return `${fileType.value.toLowerCase()}`;
              });
              if (
                typeof fileType !== 'undefined' &&
                !allowFileTypes.includes(fileType)
              ) {
                setShowFileTypeDialog(true);
                e.attachment.remove();
              } else {
                onFileUpload(e.attachment);
              }
            }
          }
        }
      });
    });
    trixEditor.current.addEventListener('trix-attachment-remove', e => {
      onFileDelete(e.attachment);
    });
    if (focusOnInit)
      setTimeout(() => {
        document.querySelector('trix-editor').focus();
      }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trixEditor]);

  useEffect(() => {
    if (!trixEditor.current) return;
    if (
      trixEditor.current.inputElement &&
      trixEditor.current.inputElement.value === value
    )
      return;

    trixEditor.current.value = value;
  }, [value]);

  const renderFileTypeErrorAlert = () => {
    return (
      <AmsAlert
        show={showFileTypeDialog}
        title="Unsupported File Type"
        text="The selected file(s) are not supported."
        type={'error'}
        showConfirm={true}
        confirmButtonText={'OK'}
        onConfirm={() => {
          setShowFileTypeDialog(false);
        }}
      />
    );
  };

  return (
    <>
      <div>{renderFileTypeErrorAlert()}</div>
      <div>
        {React.createElement('trix-editor', {
          title: id,
          ref: trixEditor,
          id: id,
        })}
      </div>
    </>
  );
};

export default Editor;
